import React, { memo } from 'react'

import { FormOnChange, MyOptionType, Select } from '@procsea/design-system'

import { useClaimReasonsQuery } from 'src/queries/shared'
import { getNewEntitiesOptions } from 'src/utils'

export interface ClaimReasonsSelectorProps {
  required?: boolean
  'data-e2e'?: string
  errorMessage?: string
  onChange: FormOnChange<Id | null>
  value?: Id | null
}

const ClaimReasonsSelector = ({
  'data-e2e': dataE2e,
  required,
  errorMessage,
  onChange,
  value,
}: ClaimReasonsSelectorProps) => {
  const { data: reasonOptions, isInitialLoading } = useClaimReasonsQuery({
    queryOptions: { select: getNewEntitiesOptions },
  })
  return (
    <Select<Id, false>
      clearable
      data-e2e={dataE2e}
      errorMessage={errorMessage}
      isLoading={isInitialLoading}
      label={gettext('reason')}
      onChange={onChange}
      options={(reasonOptions as MyOptionType<Id>[] | undefined) || []}
      placeholder={gettext('Choose a reason')}
      required={required}
      value={value}
    />
  )
}

export default memo(ClaimReasonsSelector)
